import { Component, forwardRef } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../utils/pagination";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../actions/fillCombo_action';
import AdminDrawer from "../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import { getAccountEntryPassList_action, getEntryPassPdf_action } from "../../../actions/admin_module_action/account_entry_pass_action/account_entry_pass_action";
import { exhibitionId, serviceTypeId, toastError, downloadReport, fetchAuthReport, contractorListActionId, toastSuccess, HallZoneActionId, HallListActionId, HallZoneListActionId } from "../../../utils/constants";
import Select from 'react-select';
import Modal from "react-modal";
import { data } from "jquery";
// import 'bootstrap-icons/font/bootstrap-icons.css';
import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import moment from "moment";
import ConfirmationModal from "../../../common_components/confirmationa_modal";


class AccountEntryPassList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            confirmationObj: { message: '', buttonName: '', action: '' },
            popArg: [],
            isOpenConfirmationModal: false,
            isLoading: false,
            isOpen: false,
            QrCodeImg: '',
            accountEntryPassList: [],
            contractorList: [],
            hallList: [],
            zoneList: [],
            currentPage: 1,
            EntryNo: '',
            HallId: '',
            ZoneId: '',
            ExhRegistrationNo: '',
            CompanyName: '',
            ContractorCompanyName: '',

            saveAsDraftCount: '',
            submittedCount: '',
            mainList: [],
            loginAccesslist: []
        }
        this.getAccountEntryPassList = this.getAccountEntryPassList.bind(this)
        this.renderList = this.renderList.bind(this)
        this.updateItem = this.updateItem.bind(this)
        this.onViewEntryPass = this.onViewEntryPass.bind(this)
        this.clearValue = this.clearValue.bind(this)
        this.onPassPrint = this.onPassPrint.bind(this)
        this.onPassDownload = this.onPassDownload.bind(this)

        this.handleConfirmation = this.handleConfirmation.bind(this)
    }
    handleConfirmation(flag) {
        const { confirmationObj, popArg } = this.state;
        if (flag) {
            if (confirmationObj.action == 0) {
                this.onPassDownload(popArg[0])
            }
            if (confirmationObj.action == 1) {
                this.onPassPrint(popArg[0])
            }
        }
        this.setState({ isOpenConfirmationModal: false })
    }

    componentDidMount() {
        this.setState({ loginAccesslist: JSON.parse(sessionStorage.getItem('loginDataSS'))['loginAccesslist'] })
        this.getFillList(HallListActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '');
        this.getFillList(HallZoneListActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '');
        this.getFillList(contractorListActionId, '', '', '', '', '').then(() => {
            this.getAccountEntryPassList()
        })

    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID) {
        const { } = this.state
        return new Promise((resolve, reject) => {

            this.props
                .fill_action(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID)
                .then((data) => {
                    if (data.error != 1) {
                        // voucher list
                        if (actionID === HallListActionId) {
                            this.setState({ hallList: data.data })
                            resolve()

                        }
                        if (actionID === HallZoneListActionId) {
                            this.setState({ zoneList: data.data })
                            resolve()

                        }
                        if (actionID === contractorListActionId) {
                            const array = []
                            data.data.map((item, i) => {
                                array.push(item)
                            })
                            array.push({ ContractorID: 0, CompanyName: 'Other' })
                            this.setState({
                                contractorList: array,
                                //  isLoading: false,
                            }, () => {
                                resolve(array)
                            })
                        }
                    }
                })
        })
    }

    onFilterClick(mode) {
        const { isLoading, ExitNo, HallId, ZoneId, isOpen, mainList, QrCodeImg, ExhRegistrationNo, ContractorCompanyName, CompanyName, hallList, zoneList, accountExitPassList, currentPage, dismantlePop, tcomp, tpending } = this.state
        console.log("pppp")
        var templist
        if (mode == 0) {
            templist = mainList.filter(item => item.Name == 'Submitted')
        }
        if (mode == 1) {
            templist = mainList.filter(item => item.Name == 'Save As Draft')
        }
        // if (mode == 2) {
        //     templist = mainList.filter(item => item.ExitPassStatus == 'Approved')
        // }
        // if (mode == 3) {
        //     templist = mainList.filter(item => item.ExitPassStatus == 'Rejected')
        // }
        this.setState({ accountEntryPassList: templist })
    }

    getAccountEntryPassList() {
        const { isLoading, EntryNo, HallId, ZoneId, ExhRegistrationNo, CompanyName, contractorList, accountEntryPassList, ContractorCompanyName } = this.state
        this.setState({ isLoading: true })
        this.props.getAccountEntryPassList_action(EntryNo, HallId, ZoneId, ExhRegistrationNo, CompanyName, ContractorCompanyName)
            .then((data) => {
                if (data.error != 1) {
                    var tsad = 0
                    var tapp = 0
                    data.data.length > 0 && data.data.map(item => {
                        if (item.Name == 'Save As Draft') {
                            tsad = tsad + 1
                        } else if (item.Name == 'Submitted') {
                            tapp = tapp + 1
                        }
                    })
                    var templist = JSON.parse(JSON.stringify(data.data))
                    var templist2 = templist.filter(item => item.Name == 'Submitted')
                    this.setState({ accountEntryPassList: templist2, mainList: data.data, submittedCount: tapp, saveAsDraftCount: tsad })
                    // }
                    // }
                    this.setState({ isLoading: false })
                } else {
                    toastError('Something went wrong...')
                    this.setState({ isLoading: false })

                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    onViewEntryPass(vendorID, ExhID, entryId, otherInfo, isVendor) {
        const { isLoading, EntryNo, HallId, ZoneId, ExhRegistrationNo, CompanyName, accountEntryPassList } = this.state
        this.props.navigate('/entryPass', { state: { is_view: true, isExhibitor: vendorID == null ? true : false, regId: ExhID, vendorID: vendorID, entryId: entryId, otherInfo: vendorID == 0 ? otherInfo : null, isVendor: isVendor } })
    }

    renderList(currentRecords) {
        const { isLoading, EntryNo, HallId, ZoneId, ExhRegistrationNo, CompanyName, accountEntryPassList } = this.state
        return (
            <>
                <table class="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0 me-2">
                    <thead class="table-light">
                        <tr>
                            <th class="text-center" style={{ width: '250px', }}>Entry No</th>
                            <th class="text-center">Material Entry pass Date</th>
                            <th class="text-center">Hall</th>
                            <th class="text-center">Zone</th>
                            <th class="text-center">Stall</th>
                            <th>Exhibitor</th>
                            <th style={{ width: '250px', }}>Contractor/ Service Partner Details</th>
                            <th class="text-center" style={{ width: '120px', }}>Status</th>
                            <th class="text-center" style={{ width: '100px', }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentRecords.length > 0 ? currentRecords.map(item => (
                            <tr>
                                {/* <td class="text-center">{item['Entry No'] || '-'}</td> */}
                                <td class="text-center">{item['Entry No'] != null && item['Entry No'] != '' ? item['Entry No'] : ''}</td>
                                <td class="text-center hall-td">{item['EntryDate'] != null && item['EntryDate'] != '' ? moment(item['ExitDate']).format('DD/MM/YYYY') : '-'}</td>
                                <td class="text-center hall-td">{item['Hall'] || '-'}</td>
                                <td class="text-center">{item['Zone'] || '-'}</td>
                                <td class="text-center">{item['Stall'] || '-'}</td>
                                {/* <td><span style={{ fontWeight: "600" }}>{item.VendorID == null ? item['ExhRegistrationNo'] : ''}</span> <br />{item.VendorID == null ? item['Exhibitor Details'] : ''}</td> */}
                                <td><span style={{ fontWeight: "600" }}>{item.isVendor == 0 && item['ExhRegistrationNo'] != null && item['ExhRegistrationNo'] != '' ? item['ExhRegistrationNo'] : ''}</span> {item.isVendor == 0 && item['ExhRegistrationNo'] != null && item['ExhRegistrationNo'] != '' ? <br /> : ''}{item.isVendor == 0 ? item['Exhibitor Details'] : '-'}</td>
                                <td class="vendor p-1 ">
                                    {item.VendorID != null ? <div style={{ lineHeight: '14px' }}>
                                        {item.ContractorCompanyName != null && item.ContractorCompanyName != '' ? <span class="my-1 mt-0  ha-view-com" style={{ fontSize: "12px" }}><i class="fa fa-building-o grid-icon"></i>&nbsp;
                                            {item.ContractorCompanyName || '-'} </span> : '-'}
                                        <br />
                                        {item['Person Name'] != null && <span class="mt-0  ha-view-com" style={{ fontSize: "12px" }}><i class="fa fa-user grid-icon"></i>&nbsp; {item['Person Name']} </span>}
                                        <br />
                                        {item['Mobile Number'] != null && <span class="mt-1" style={{ fontSize: "12px" }}> <i class="fa fa-phone grid-icon"></i>
                                            &nbsp; {item['Mobile Number']}  </span>}
                                        <br />
                                        {item['Email ID'] != null && <span style={{ fontSize: "12px" }}> <i class="fa fa-envelope grid-icon"></i>
                                            &nbsp; {item['Email ID']} </span>}
                                        <br />
                                    </div> : '-'}
                                </td>
                                <td class={'text-center text-aqua'}>
                                    <i class={item['Name'] == 'Submitted' ? 'fa fa-check-circle' : "fa fa-floppy-o fs-6"}></i>&nbsp;{item['Name']}</td>
                                <td class="text-left act-col">
                                    <a style={{ cursor: 'pointer' }} class="border-end pe-1 me-1" onClick={() => this.onViewEntryPass(item.VendorID, item.ExhRegistrationID, item.ExhEntryPassHdrID,
                                        {
                                            companyName: item['Exhibitor Details'],
                                            personName: item['Person Name'],
                                            contactNo: item['Mobile Number'],
                                            email: item['Email ID']
                                        },
                                        item.isVendor
                                    )}>
                                        <i class="bi bi-eye fs-6 grid-icon p-1 rounded-1 px-1 fw-normal" title="View Material Entry pass"></i>
                                    </a>
                                    {this.getDownloadAccess() && <i style={{ cursor: 'pointer' }} class="ri-download-line fs-6 grid-icon p-1 rounded-1 px-1 fw-normal border-end pe-2 me-1"
                                        // onClick={() => this.onPassDownload(item.ExhEntryPassHdrID)}
                                        onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to Download?`, buttonName: "Download", action: 0 }, popArg: [item.ExhEntryPassHdrID] })}></i>}
                                    {this.getDownloadAccess() && <i style={{ cursor: 'pointer' }} class="ri-printer-line fs-6 grid-icon p-1 rounded-1 px-1 fw-normal border-end pe-2 me-1"
                                        // onClick={() => this.onPassPrint(item.ExhEntryPassHdrID)}
                                        onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to View?`, buttonName: "View", action: 1 }, popArg: [item.ExhEntryPassHdrID] })}
                                    ></i>}
                                    {this.getSpecialAccess() && <a style={{ cursor: 'pointer' }} onClick={() => {
                                        if (item.QRcodeImg) {
                                            const byteArray = item.QRcodeImg.data || item.QRcodeImg;
                                            const base64 = btoa(String.fromCharCode(...byteArray));
                                            this.setState({ QrCodeImg: `data:image/png;base64,${base64}`, isOpen: true });
                                        }
                                    }}>
                                        <i class="fa fa-qrcode fs-6 grid-icon p-1 rounded-1 px-1 fw-normal qrIcon" title="Scan to Print"></i>
                                    </a>}
                                </td>
                            </tr>
                        )) : <tr>
                            <td colSpan={12} className="text-center">Record not found</td>
                        </tr>}
                    </tbody>
                </table>
            </>
        )
    }

    onPassDownload(id) {
        console.log(id)
        this.setState({ isLoading: true })
        this.props.getEntryPassPdf_action(id)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false })
                    console.log("Proforma Pdf Download", data)
                    var url = `${downloadReport}?SessionIdentifier=${data}&Export=true`;
                    const win = window.location.replace(url, '_blank');
                    if (win != null) {
                        win.focus();
                    }
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })

    }

    async onPassPrint(id) {
        console.log(id)
        this.setState({ isLoading: true })
        try {
            var list = [];
            const mapdata1 = {
                "ParameterName": "@ExhEntryPassHdrID",
                "ParameterValue": id,
                "ParameterDataType": "int"
            }
            list.push(mapdata1);
            const mapData = {
                "report_name": 'EntryPass.rpt',
                "parameter_details": list
            }
            console.log("xxxxxxxxxxxxxxxxxxxxx", mapData)
            const res = await axiosPost(fetchAuthReport, mapData);
            this.setState({ isLoading: false });

            if (res != null) {
                var url = `${downloadReport}?SessionIdentifier=${res}`;
                const win = window.open(url, '_blank', 'noopener,noreferrer');
                if (win != null) {
                    win.focus();
                }
            }
        } catch (err) {
            console.error(err);
        }
    }


    // Update Current Page
    updateItem(item) {
        const { accountEntryPassList } = this.state
        this.setState({ currentPage: item });
    }
    clearValue() {
        this.setState({
            EntryNo: '',
            HallId: '',
            ZoneId: '',
            ExhRegistrationNo: '',
            CompanyName: '',
            ContractorCompanyName: '',
        })
        setTimeout(() => {
            this.getAccountEntryPassList()
        }, 100);
    }

    getWriteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '39');
        if (moduleAccess) {
            return moduleAccess.WriteAccess;
        } else {
            return false
        }
        return false;
    }

    getUpdateAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '39');
        if (moduleAccess) {
            return moduleAccess.UpdateAccess;
        } else {
            return false
        }
        return false;
    }

    getDeleteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '39');
        if (moduleAccess) {
            return moduleAccess.DeleteAccess;
        } else {
            return false
        }
        return false;
    }

    getDownloadAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '39');
        if (moduleAccess) {
            return moduleAccess.DownloadAccess;
        } else {
            return false
        }
        return false;
    }

    getSendAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '39');
        if (moduleAccess) {
            return moduleAccess.SendAccess;
        } else {
            return false
        }
        return false;
    }


    getSpecialAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '39');
        if (moduleAccess) {
            return moduleAccess.Is_SpecialAccess;
        } else {
            return false
        }
        return false;
    }

    render() {
        const { isLoading, isOpenConfirmationModal, EntryNo, HallId, ZoneId, isOpen, QrCodeImg, ExhRegistrationNo, ContractorCompanyName, CompanyName, hallList, zoneList, accountEntryPassList, currentPage } = this.state
        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = accountEntryPassList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(accountEntryPassList.length / recordsPerPage)
        return (
            <>

                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}

                <ToastContainer />
                <HeaderWithLogo />
                {/* <HeaderWithLogo /> */}
                <>
                    <AdminDrawer />
                    {/* <div className="app-content with-dr-container com-height"> */}

                    <div className="main-container with-dr-container">
                        <div className="row m-0">
                            <div className="breadcrumb-scroll-fixed">
                                <h6 className="mb-0 p-2 text-white">Material Entry pass</h6>
                            </div>
                        </div>
                        <div className="admin-top-space p-2 pt-0">
                            <main id="main">
                                <section class="section p-0" >
                                    <div className="main-container pt-3">
                                        <div className="row m-0">
                                            <div className="col-xl-2 mb-3">
                                                <label class="">Entry No</label>
                                                <input type="text" class="form-control form-control-sm w-100" value={EntryNo} onChange={(e) => this.setState({ EntryNo: e.target.value })} />
                                            </div>

                                            <div className="col-xl-2 mb-3">
                                                <label class="">Hall</label>
                                                <select
                                                    className="form-control form-control-sm w-100"
                                                    id="roledb"
                                                    style={{ textAlign: "left" }}
                                                    value={HallId}
                                                    // disabled={isView || isReadOnly}
                                                    onChange={(e) => this.setState({ HallId: e.target.value })}
                                                >
                                                    <option value="">Select</option>
                                                    {hallList.length > 0 && hallList.map((data) => (
                                                        <option key={data.HallId} value={data.HallId}>{data.HallName}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="col-xl-2 mb-3">
                                                <label class="">Zone</label>
                                                <select
                                                    className="form-control form-control-sm w-100"
                                                    id="roledb"
                                                    style={{ textAlign: "left" }}
                                                    value={ZoneId}
                                                    // disabled={isView || isReadOnly}
                                                    onChange={(e) => this.setState({ ZoneId: e.target.value })}
                                                >
                                                    <option value="">Select</option>
                                                    {zoneList.length > 0 && zoneList.map((data) => (
                                                        <option key={data.ZoneID} value={data.ZoneID}>{data.Zone}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="col-xl-2 mb-3">
                                                <label class="">Exhibitor Reg. No.</label>
                                                <input type="text" class="form-control form-control-sm w-100" value={ExhRegistrationNo} onChange={(e) => this.setState({ ExhRegistrationNo: e.target.value })} />
                                            </div>

                                            <div className="col-xl-2 mb-3">
                                                <label class="">Exhibitor</label>
                                                <input type="text" class="form-control form-control-sm w-100" value={CompanyName} onChange={(e) => this.setState({ CompanyName: e.target.value })} />
                                            </div>

                                            <div className="col-xl-2 mb-3">
                                                <label class="">Contractor</label>
                                                <input type="text" class="form-control form-control-sm w-100" value={ContractorCompanyName} onChange={(e) => this.setState({ ContractorCompanyName: e.target.value })} />
                                            </div>
                                            <div className="d-flex justify-content-end">
                                                <div className="d-flex gap-2" role="group" aria-label="Basic example">
                                                    <button
                                                        type="button"
                                                        class="btn btn-aqua"
                                                        onClick={(e) => this.getAccountEntryPassList()}>
                                                        Search
                                                    </button>
                                                    <button
                                                        type="button"
                                                        class="btn btn-gray"
                                                        onClick={() => this.clearValue()}>
                                                        Clear
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="d-flex justify-content-end align-items-center w-100  mb-1">
                                        <div class="d-flex align-items-center gap-1">
                                            <div class="p-1 rounded-1 status-btn mb-2" onClick={() => this.onFilterClick(1)} style={{ cursor: 'pointer' }} >
                                                <i class="fa fa-floppy-o fs-6"></i>&nbsp;
                                                <span class="text-aqua">Save as Draft:</span>
                                                <strong class="ms-1 status-name">{this.state.saveAsDraftCount}</strong>
                                            </div>
                                            <div class="p-1 rounded-1 status-btn mb-2 me-2" onClick={() => this.onFilterClick(0)} style={{ cursor: 'pointer' }} >
                                                <i class="fa fa-check-circle fs-6"></i>&nbsp;
                                                <span class="text-aqua">Submiited:</span>
                                                <strong class="ms-1 status-name">{this.state.submittedCount}</strong>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row mx-3 me-1">
                                        <div class="table-responsive sticky-table-wrapper service-list-grid p-0">

                                            {this.renderList(accountEntryPassList.length > 0 ? currentRecords : [])}
                                            {/* //here */}
                                        </div>
                                    </div>
                                    <div class="mt-2 float-left trp">

                                        {
                                            accountEntryPassList.length > 0 ?
                                                <Pagination
                                                    nPages={nPages}
                                                    currentPage={currentPage}
                                                    setCurrentPage={this.updateItem}
                                                /> : <></>
                                        }
                                        <div class="table-record-pages">
                                            Page {currentPage} of {nPages}
                                        </div>
                                    </div>

                                </section>
                            </main>
                        </div>

                        <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                            <div className="modal-dialog modal-sm">
                                <div className="modal-content confirm-logout">
                                    <div class="modal-header p-2 text-center">
                                        <h5 class="modal-title modal_title_text">Scan below QR in Kiosk Device for print Material Entry pass</h5>
                                        {/* <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isOpen: false })} style={{ background: '#eeeeee' }}><span aria-hidden="true" class="pop-cancel">&times;</span></button> */}
                                    </div>
                                    <div class="modal-body">
                                        <div class="row">
                                            <div class="col-md-12 text-center">
                                                <img
                                                    src={QrCodeImg}
                                                    alt="QR Code"
                                                    className="rounded-2xl shadow-lg w-64 h-64 object-contain"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer p-1">
                                        <div class="form-group text-right mod-fot">
                                            <button type="button" class="btn btn-gray" data-dismiss="modal" onClick={() => this.setState({ isOpen: false })}>Close</button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </Modal>
                    </div>
                </>
            </>)
    }
}

export default withRouter(connect(null, {
    fill_action, getEntryPassPdf_action,
    getAccountEntryPassList_action
})(AccountEntryPassList));